/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Version_ReplacedInputs */

const cs_documents_version_replaced = /** @type {(inputs: Documents_Version_ReplacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nová verze nahrána`)
};

const en_documents_version_replaced = /** @type {(inputs: Documents_Version_ReplacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New version uploaded`)
};

/**
* | output |
* | --- |
* | "New version uploaded" |
*
* @param {Documents_Version_ReplacedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_version_replaced = /** @type {((inputs?: Documents_Version_ReplacedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Version_ReplacedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_version_replaced(inputs)
	return cs_documents_version_replaced(inputs)
});